export default __webpack_public_path__ + "static/media/41.45f0a855.jpeg";